// SessionExpiredPage.tsx
import { useLocation } from "react-router"

import { AuthShell } from "@/components/auth/AuthShell"
import { msalInstance } from "@/main"

export function SessionExpiredPage() {
  const location = useLocation()

  const params = new URLSearchParams(location.search)
  let returnTo = params.get("returnTo") || "/"

  // avoid bouncing back to session-expired
  const isSafePath = (path: string) => {
    return path.startsWith("/") && !path.includes("://")
  }
  if (!isSafePath(returnTo)) {
    returnTo = "/"
  }

  const handleSignInAgain = () => {
    msalInstance.loginRedirect({
      scopes: ["api://3a90408c-832c-4f33-bbd2-4c8ff48bc7bc/API.Access"],
      redirectUri: "/", // land back in the SPA shell
      state: returnTo, // 👈 where main.tsx will send them after login
      prompt: "login", // optional: force re-auth vs silent SSO
    })
  }

  return (
    <AuthShell
      title="Your session has expired, please reauthenticate"
      description="Please sign in again to continue using the dashboard."
      primaryLabel="Sign in again"
      onPrimaryClick={handleSignInAgain}
    />
  )
}
